module.exports = __webpack_public_path__ + "static/media/charger-pin-public.20b92644.svg";